export async function getJobOrders(
  status = [],
  serviceReportStatus = [],
  billingRecordStatus = [],
  startDate = null,
  endDate = null,
  clientId = null,
  technicianId = null
) {
  try {
    // Prepare the base API URL
    let apiUrl =
      "https://eduscdobg8.execute-api.ap-southeast-1.amazonaws.com/prod/getJobOrders";

    // Initialize query parameters
    const queryParams = [];

    // Add status as a comma-separated string if provided
    if (status.length > 0) {
      queryParams.push(`status=${status.map(encodeURIComponent).join(",")}`);
    }

    // Add serviceReportStatus as a comma-separated string if provided
    if (serviceReportStatus.length > 0) {
      queryParams.push(
        `service_report_status=${serviceReportStatus
          .map(encodeURIComponent)
          .join(",")}`
      );
    }

    // Add billingRecordStatus as a comma-separated string if provided
    if (billingRecordStatus.length > 0) {
      queryParams.push(
        `billing_record_status=${billingRecordStatus
          .map(encodeURIComponent)
          .join(",")}`
      );
    }

    // Add client_id if provided
    if (clientId) {
      queryParams.push(`client_id=${encodeURIComponent(clientId)}`);
    }

    // Add start_date and end_date if both are provided
    if (startDate && endDate) {
      queryParams.push(`start_date=${encodeURIComponent(startDate)}`);
      queryParams.push(`end_date=${encodeURIComponent(endDate)}`);
    }

    // Add technician_id if provided
    if (technicianId) {
      queryParams.push(`technician_id=${encodeURIComponent(technicianId)}`);
    }

    // Add query parameters to the API URL
    if (queryParams.length > 0) {
      apiUrl += `?${queryParams.join("&")}`;
    }

    // Make the API call
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    // Check for a successful response
    if (response.ok) {
      const data = await response.json();
      return data; // Return the list of job orders
    } else {
      console.error(
        `Error: Failed to fetch job orders. Status: ${response.status}`
      );
      return null;
    }
  } catch (error) {
    console.error(
      "Error: Network or other error occurred while fetching job orders.",
      error
    );
    return null;
  }
}

export async function getJobOrder(id) {
  try {
    const response = await fetch(
      `https://mfh00xbutl.execute-api.ap-southeast-1.amazonaws.com/prod/getJobOrder/${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return await response.json(); // Directly return the parsed JSON response
  } catch (error) {
    console.error("Error fetching job order:", error);
    return null; // Return null on error
  }
}

export async function getJobOrdersByStatusAndCompetency(
  client_id,
  start_date,
  end_date,
  address_id
) {
  try {
    // Construct query parameters
    const queryParams = new URLSearchParams({
      client_id: client_id,
      status: "Done",
      competency: "termite_control",
      start_date: start_date,
      end_date: end_date,
      address_id: address_id,
    });

    // API endpoint with query parameters
    const url = `https://wrwqvqlgd9.execute-api.ap-southeast-1.amazonaws.com/prod/getJobOrdersByStatusAndCompetency?${queryParams.toString()}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      console.error("Error fetching job orders:", response.statusText);
      return null; // Return null if the response is not successful
    }

    return await response.json(); // Directly return the parsed JSON response
  } catch (error) {
    console.error("Error fetching job orders:", error);
    return null; // Return null on error
  }
}

export async function putJobOrder(id, jobOrderParameters = {}) {
  // Prepare the payload for submission using the passed jobOrderParameters
  const submitData = {
    ...jobOrderParameters, // Spread all the properties from jobOrderParameters
  };

  try {
    console.log("Submitting updated job order data:", submitData);

    const response = await fetch(
      `https://252dj6bfla.execute-api.ap-southeast-1.amazonaws.com/prod/putJobOrder/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(submitData), // Convert the payload to JSON
      }
    );

    const result = await response.json();

    if (response.ok) {
      console.log("Job order updated successfully!", result);
      return { success: true, data: result };
    } else {
      console.error("Error updating job order:", result);
      return { success: false, error: result };
    }
  } catch (error) {
    console.error(
      "Network or other error occurred while updating job order:",
      error
    );
    return { success: false, error };
  }
}

export async function postJobOrder(jobOrderParameters = {}) {
  // Construct the payload with spread syntax
  const jobOrderPayload = {
    job_order_data: [
      {
        ...jobOrderParameters, // Spread all properties from jobOrderParameters
        user_create: jobOrderParameters.user_create || "system_default", // Default value
        user_update: jobOrderParameters.user_update || "system_default", // Default value
      },
    ],
  };

  try {
    // Make the API call
    const response = await fetch(
      "https://dq2vzx2zr6.execute-api.ap-southeast-1.amazonaws.com/prod/postJobOrder",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(jobOrderPayload),
      }
    );

    // Check for a successful response
    if (response.ok) {
      return await response.json(); // Return the response as JSON
    } else {
      console.error(
        `Error: Failed to post job order data. Status: ${response.status}`
      );
      return null;
    }
  } catch (error) {
    // Catch any network or other errors
    console.error(
      "Error: Network or other error occurred while posting job order data.",
      error
    );
    return null;
  }
}

//update the JobOrderReceipt Link or the JobOrderReports Link
export async function patchJobOrderLink(id, jobOrderParameters = {}) {
  // Prepare the payload for submission using the passed jobOrderParameters
  const submitData = {
    ...jobOrderParameters, // Spread all properties from jobOrderParameters
  };

  try {
    console.log("Submitting updated job order link data:", submitData);

    const response = await fetch(
      `https://f6ve053pxf.execute-api.ap-southeast-1.amazonaws.com/prod/patchJobOrderLink/${id}`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(submitData), // Convert the payload to JSON
      }
    );

    const result = await response.json();

    if (response.ok) {
      console.log("Job order link updated successfully!", result);
      return { success: true, data: result };
    } else {
      console.error("Error updating job order link:", result);
      return { success: false, error: result };
    }
  } catch (error) {
    console.error(
      "Network or other error occurred while updating job order link:",
      error
    );
    return { success: false, error };
  }
}

export async function getJobOrdersByRecurrenceId(id) {
  try {
    const response = await fetch(
      `https://4d62z5udg3.execute-api.ap-southeast-1.amazonaws.com/prod/getJobOrdersByRecurrenceId/${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch job orders: ${response.statusText}`);
    }

    return await response.json(); // Return parsed JSON if successful
  } catch (error) {
    console.error("Error fetching job orders by recurrence_id:", error);
    return null; // Return null if there is an error
  }
}

export async function deleteJobOrder(id) {
  try {
    const response = await fetch(
      `https://yvpso85t57.execute-api.ap-southeast-1.amazonaws.com/prod/deleteJobOrder/${id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const result = await response.json();

    if (response.ok) {
      console.log("Job order deleted successfully!", result);
      return { success: true, data: result };
    } else {
      console.error("Error deleting job order:", result);
      return { success: false, error: result };
    }
  } catch (error) {
    console.error(
      "Network or other error occurred while deleting job order:",
      error
    );
    return { success: false, error };
  }
}
